import { DefaultButton, PrimaryButton } from "@fluentui/react";
import React, { useContext, useState } from "react";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import "../../../styles/styles.css";
import { t } from "i18next";
import themeContext from "../../../../../context/theme/ThemeContext";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import { DOCUMENT_MODALITIES } from "../../../../../constants/Constants";

const defaultButtonStyles = {
  root: {
    width: "140px",
    height: "33px",
    borderRadius: "5px",
    marginLeft: "10px",
    border: "1px solid rgb(195, 196, 205)",
  },
  rootHovered: {
    backgroundColor: "black",
  },
  rootPressed: {
    backgroundColor: "black",
  },
};

const primaryButtonStyles = {
  root: {
    width: "140px",
    height: "33px",
    borderRadius: "5px",
    marginLeft: "10px",
  },
  rootHovered: {
    color: "white",
  },
  rootPressed: {
    color: "white",
  },
};

const ShowOriginal = () => {
  const { 
    setIsOutlineEnabled,
    isOutlineEnabled, 
    isHeatMapEnabled,
    setIsHeatMapEnabled,} =
    useContext(studyviewerContext);

  const {
    activeViewportIndex,
    originalImageActiveState,
    setOriginalImageActiveState,
    viewportSeriesData,
  } = useContext(ViewportContext);

  // A document series (Encapsulated PDF or SR) has no pixel data, so it has no
  // downsized/original pair for this toggle to switch between - the viewport is
  // showing the document, not a cornerstone image. Disable rather than hide the
  // button so the toolbar does not reflow when the active viewport moves
  // between an image series and a document.
  const isDocumentSeries = DOCUMENT_MODALITIES.includes(
    viewportSeriesData?.[activeViewportIndex]?.modality
  );

  const [disableHeatmap, setDisableHeatmap] = useState(false);
  const [disableOutline, setDisableOutline] = useState(false);

  const handleClick = () => {
    if (isDocumentSeries) return;
    let temp = originalImageActiveState.map((state, index) => {
      console.log("orignalImage active state", state);
      if (index === activeViewportIndex) {

        if(state === false) {
          if(isOutlineEnabled) {
            setDisableOutline(true);
            setIsOutlineEnabled(false);
          } 
          if(isHeatMapEnabled) {
            setDisableHeatmap(true);
            setIsHeatMapEnabled(false);
          }
        } else {
          if(disableOutline === true) {
            setDisableOutline(false);
            setIsOutlineEnabled(true);
          }
          if(disableHeatmap === true) {
            setDisableHeatmap(false);
            setIsHeatMapEnabled(true);
          }
        }

        return !state;
      } else return state;
    });
    setOriginalImageActiveState(temp);
  };

  const buttonStyle = {
    root: {
      height: "33px",
      border: "1px solid rgb(195, 196, 205)",
    },
  };

  if (originalImageActiveState[activeViewportIndex]) {
    return (
      // <PrimaryButton
      //   text="Show Original"
      //   styles={primaryButtonStyles}
      //   onClick={handleClick}
      // />
      <CustomPrimaryButton
        active={true}
        disabled={isDocumentSeries}
        text={t("button.show-downsize")}
        onClick={handleClick}
      />
    );
  } else {
    return (
      // <DefaultButton
      //   text="Show Original"
      //   styles={defaultButtonStyles}
      //   onClick={handleClick}
      // />
      <CustomPrimaryButton
        active={false}
        disabled={isDocumentSeries}
        text={t("button.show-original")}
        onClick={handleClick}
      />
    );
  }
};

export default ShowOriginal;

export const CustomPrimaryButton = (props) => {
  const { getThemeColor,themeName } = useContext(themeContext);
  return (
    <>
      <div
        style={{
          width: "73px",
          marginLeft:"4px",
          background: props.active ? "rgb(0, 120, 212)" : "unset",
          border: props.active ? "1px solid transparent" :  themeName != "light"?"1px solid #C3C4CD": "1px solid rgb(41 41 41)",
          // Matches the not-allowed cursor the sibling HeatMap/Outline tools use
          // for their disabled state.
          opacity: props.disabled ? 0.4 : 1,
          cursor: props.disabled ? "not-allowed" : "pointer",
        }}
        className="primay-button-topbar"
        onClick={props.disabled ? undefined : props.onClick}
      >
        <span className="pathology-text-topbar" style={{color: props.active || themeName !== "light" ? "#FFF" : "#000"}}>{props.text}</span>
      </div>
    </>
  );
};
